import SuspenseWrapper from '@monofe/ui-common/misc/SuspenseWrapper';
import { injectLog } from '@monofe/util';
import loader from '../common/loader';
import type { ILanguageSelectIndexProps } from './interface';
import { ILanguageSelectType } from './interface';

const MainViewList = loader(() => import('./list'));

function IndexView(props: ILanguageSelectIndexProps): JSX.Element {
    const log = injectLog();

    switch (props.type) {
        case ILanguageSelectType.List:
            break;

        case ILanguageSelectType.GridFlag:
            log.error('Unsupported Language Selection Type grid flag, falling back to list type');
            break;

        case ILanguageSelectType.GridTile:
            log.error('Unsupported Language Selection Type grid tile, falling back to list type');
            break;

        default:
            return <span>Unknown Language Selection Type {props.type}</span>;
    }

    // TODO: replace #type with props.type, when other types are supported
    const type = ILanguageSelectType.List;

    return (
        <SuspenseWrapper fallback={null}>
            {type === ILanguageSelectType.List && <MainViewList {...props} />}
        </SuspenseWrapper>
    );
}

export default IndexView;
